import {action, observable} from 'mobx';
import Container, {Service} from 'typedi';
import {CheckTokenActivateDTO, HttpService, ResponseDTO} from '@/shared';
import {IResponseActivate} from '@/types';
import {RegisterPartnerDTO, SyncBoDTO} from '@/shared/dto/activate.dto';

@Service()
export class ActivateService {
  @observable
  private httpService = Container.get(HttpService);

  @action.bound
  public async checkTokenActivate(
    checkTokenActivateDTO: CheckTokenActivateDTO,
  ): Promise<ResponseDTO<IResponseActivate>> {
    return this.httpService.request(checkTokenActivateDTO);
  }
  public async registerPartnerAdmin(
    registerPartnerDTO: RegisterPartnerDTO,
  ): Promise<ResponseDTO> {
    return this.httpService.request(registerPartnerDTO);
  }
  public async syncBoTemplates(syncBoDTO: SyncBoDTO): Promise<ResponseDTO> {
    return this.httpService.request(syncBoDTO);
  }
}
